import styled from "styled-components";
import React from "react";
import { Button } from "@material-ui/core";

export default function NotFound() {
  return (
    <MainDiv>
      <MainDiv1>
        <MainDiv2>
          <h3>Oops! Page not found</h3>
          <h1>
            <span>4</span>
            <span>0</span>
            <span>4</span>
          </h1>
        </MainDiv2>
        <h2>we are sorry, but the page you requested was not found</h2>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            window.appStore.goToHomePage();
          }}
        >
          Home
        </Button>
      </MainDiv1>
    </MainDiv>
  );
}

export function SomethingWentWrong() {
  return (
    <MainDiv>
      <MainDiv1>
        <MainDiv2>
          <h3>
            Something went wrong. Please
            <span onClick={() => window.location.reload()} className="refresh">
              {" "}
              refresh{" "}
            </span>
            the page
          </h3>
          <h1>
            <span>O</span>
            <span>O</span>
            <span>P</span>
            <span>S</span>
            <span>!</span>
          </h1>
        </MainDiv2>
        <h2>
          we are sorry. if the issue persists, please contact tigersheet
          support.
        </h2>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            window.appStore.goToHomePage();
            window.location.reload();
          }}
        >
          Home
        </Button>
      </MainDiv1>
    </MainDiv>
  );
}

const MainDiv = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  text-align: center;
`;

const MainDiv1 = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  h2 {
    font-size: 20px;
    font-weight: 400;
    text-transform: uppercase;
    color: #000;
    margin-top: 0;
    /* margin-bottom: 25px; */
  }
`;
const MainDiv2 = styled.div`
  position: relative;
  height: 240px;

  h3 {
    position: relative;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: #262626;
    margin: 0;
    letter-spacing: 3px;
    padding-left: 6px;
    z-index: 111;
    .refresh {
      color: #237ff4;
      cursor: pointer;
    }
  }
  h1 {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-size: 252px;
    font-weight: 900;
    margin: 0;
    color: #262626;
    text-transform: uppercase;
    letter-spacing: -40px;
    margin-left: -20px;
    span {
      text-shadow: -8px 0 0 #fff;
    }
  }
`;
